import React from 'react';
import Menu from './Menu';
import TopHeaderContainer from '../../containers/layout/TopHeaderContainer';
import { MuiThemeProvider } from '@material-ui/core/styles';
import {fetchTheme} from "../../style/MUIThemes";
import axios from 'axios';

class MainLayout extends React.Component {

    getSessionCall = async () => {
        try{
                if(!axios.defaults.headers.common["Authorization"]){
                const response = await axios.get(process.env.REACT_APP_BACKEND_URL + "/auth/read-session");
                axios.defaults.headers.common["Authorization"] = "Bearer " + response.data;
                return response.data;
            }
        }
        catch(e){
            console.log("refreshing session error: " + e);
        }
    };

 componentWillMount(){
     this.getSessionCall();
}

    render() {
        return (
            <div id="outer-container">
                <MuiThemeProvider theme={fetchTheme("form")}>
                    <Menu
                        path= {this.props.location.pathname}
                    />
                    <TopHeaderContainer
                        path= {this.props.location.pathname}
                    />
                    <div id="page-wrap" style={ this.props.children.props.location.pathname === "/dashboard" ? {paddingRight:"0"} : null}>
                        {this.props.children}
                    </div>
                </MuiThemeProvider>
            </div>
        );
    }
}
export default MainLayout;
